import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Typography, Box, Chip, DialogActions, Alert } from '@mui/material';
import { Icon } from '@iconify/react';
export const UploadedFileType = {
    'application/pdf': 'pdf',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx'
};
const defaultAllwedFiles = {
    "application/pdf": [".pdf"],
    "application/msexcel": [".xls", ".xlsx"],
    "text/plain": [".txt"],
};
export const DynamicFileUploader = ({ onFilesChange, onCloce, onUpload, typeAllowed, maxFiles = Infinity, maxFileSizeInBytes }) => {
    const [files, setFiles] = React.useState([]);
    const [error, setError] = React.useState(null);
    const onDrop = useCallback((acceptedFiles, rejections) => {
        var _a, _b;
        if (acceptedFiles.length) {
            const fileBytes = acceptedFiles[0].size;
            if (maxFileSizeInBytes && fileBytes > maxFileSizeInBytes) {
                setError('File size exceeds the maximum allowed size');
                return;
            }
        }
        if (rejections.length > 0 && ((_b = (_a = rejections[0]) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            rejections[0].errors.forEach(error => {
                if ((error === null || error === void 0 ? void 0 : error.code) === 'file-invalid-type') {
                    setError('Invalid File Type. Please Upload Supported File Type');
                }
            });
            return;
        }
        if (files.length + acceptedFiles.length > maxFiles) {
            setError(`You can only upload up to ${maxFiles} files.`);
            return;
        }
        setError(null);
        const updatedFiles = [...files, ...acceptedFiles];
        setFiles(updatedFiles);
        if (onFilesChange) {
            onFilesChange(updatedFiles);
        }
    }, [files, onFilesChange]);
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: typeAllowed !== null && typeAllowed !== void 0 ? typeAllowed : defaultAllwedFiles,
        multiple: true,
    });
    const handleRemoveFile = (fileToRemove) => {
        console.log(fileToRemove, 'file to remove');
        const updatedFiles = files.filter(file => file !== fileToRemove);
        setFiles(updatedFiles);
        if (onFilesChange) {
            onFilesChange(updatedFiles);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { ...getRootProps(), sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '200px',
                    border: '2px dashed #ccc',
                    borderRadius: '4px',
                    padding: '16px',
                    backgroundColor: '#f9f9f9',
                    overflowY: 'auto',
                    position: 'relative',
                    textAlign: 'center',
                }, children: [_jsx("input", { ...getInputProps() }), _jsx(Button, { variant: "contained", component: "span", startIcon: _jsx(Icon, { icon: 'mdi:CloudUploadIcon' }), sx: { marginBottom: '16px' }, children: "Upload Files" }), error && (_jsx(Alert, { severity: "error", sx: { marginBottom: '16px' }, children: error })), files.length > 0 && (_jsx(Box, { children: files.map(file => (_jsx(Chip, { label: file.name, onDelete: () => handleRemoveFile(file), deleteIcon: _jsx(Icon, { icon: "mdi:trash-can-outline", color: " #FF0000" }), sx: { margin: '4px' } }, file.name))) })), files.length === 0 && (_jsx(Typography, { variant: "body1", children: "Drag & drop files here, or click \"Upload Files\" to select files" }))] }), _jsx(Box, { children: _jsxs(DialogActions, { sx: { paddingBottom: 'unset' }, children: [_jsx(Button, { onClick: () => onCloce(), children: "Close" }), _jsx(Button, { disabled: !(files === null || files === void 0 ? void 0 : files.length), onClick: () => onUpload(files), autoFocus: true, children: "Upload" })] }) })] }));
};
